import { Dialog, DialogContent, Grid2, Typography } from "@mui/material";
import React from "react";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import XCloseIco from "../../../../assets/icons/XCloseIco";

export default function AddDelivery({
  openDialog,
  handleCloseDialog,
  selectedRowData = true,
}) {
  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={openDialog}
      onClose={handleCloseDialog}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          background: "#FFF",
          boxShadow:
            "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        },
      }}
    >
      <StyledSpaceBetweenBox padding={"10px 10px 10px 20px"}>
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.1598 17.5V12.5M13.6598 15H18.6598M10.3265 12.5H6.99316C5.44003 12.5 4.66346 12.5 4.05089 12.7537C3.23413 13.092 2.58521 13.741 2.2469 14.5577C1.99316 15.1703 1.99316 15.9469 1.99316 17.5M13.2432 2.7423C14.4648 3.23679 15.3265 4.43443 15.3265 5.83333C15.3265 7.23224 14.4648 8.42988 13.2432 8.92437M11.5765 5.83333C11.5765 7.67428 10.0841 9.16667 8.24316 9.16667C6.40222 9.16667 4.90983 7.67428 4.90983 5.83333C4.90983 3.99238 6.40222 2.5 8.24316 2.5C10.0841 2.5 11.5765 3.99238 11.5765 5.83333Z"
            stroke="#344054"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <CommonButton
          onClick={handleCloseDialog}
          padding={"10px"}
          background={"rgba(127, 86, 217, 0.04)"}
          border="rgba(127, 86, 217, 0.5)"
          height={"100%"}
          value={<XCloseIco />}
          boxShadow="0px 0px 10px 0px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 4px 0px rgba(0,0,0,0.12)"
        />
      </StyledSpaceBetweenBox>

      <DialogContent>
        <Grid2 spacing={2} container>
          <Grid2 size={12}>
            <Typography variant="h2" color="#101828">
              {selectedRowData ? "Edit Key Deliverable" : "Add Key Deliverable"}
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <Typography variant={"h6"} color={"#344054"} marginBottom={"10px"}>
              {"Key Deliverable"}
            </Typography>
            <CommonTextField
              fullWidth
              placeholder="Enter Key Deliverable"
              //   value={formData?.deliverable || ""}
              //   onChange={handleChangeText("deliverable")}
              padding={"0px"}
              multiline
              placeholderFontSize={"15px"}
              rows={4}
            />
          </Grid2>

          <Grid2 size={12}>
            <CommonButton
              variant="contained"
              color="white"
              background="#7F56D9"
              fontWeight="600"
              value={
                selectedRowData ? "Edit Key Deliverable" : "Add Key Deliverable"
              }
              padding="10px"
              fullWidth
              width={"100%"}
              //   onClick={handleAddTeam}
            />
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
}
